import { render } from "./MSpinner.vue?vue&type=template&id=2aef6d22&scoped=true"
import script from "./MSpinner.vue?vue&type=script&lang=js"
export * from "./MSpinner.vue?vue&type=script&lang=js"

import "./MSpinner.vue?vue&type=style&index=0&id=2aef6d22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aef6d22"]])

export default __exports__